import { render, staticRenderFns } from "./NBARoster.vue?vue&type=template&id=483a7904&"
import script from "./NBARoster.vue?vue&type=script&lang=js&"
export * from "./NBARoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports